import { Component,
         OnInit,
         ViewEncapsulation,
         ViewChild,
         ChangeDetectorRef } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { Router } from '@angular/router';

const mapboxgl = require('../../../node_modules/mapbox-gl/dist/mapbox-gl.js');
const Map = mapboxgl.Map
declare var _:any;

import { SessionService } from '../api/session.service';
import { AgencyLocationService } from '../api/resources/agency-location.service';
import { AgencyLocation } from '../api/resources/agency-location';
import { MapService } from '../api/resources/map.service';
import { AgencyService } from '../api/resources/agency.service';

@Component({
  selector: 'app-location-list',
  templateUrl: './location-list.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./location-list.component.less'],
  providers: [
    SessionService,
    AgencyLocationService,
    MapService,
    AgencyService
  ]
})
export class LocationListComponent implements OnInit {
  @ViewChild('locationList') listHost: any;
  @ViewChild('mapContainer') mapHost: any;
  agencyName: string;
  locations: Array<AgencyLocation>;
  map: any;
  markerOffset: Number = -6; // negative half of marker width/height (set in css)
  bounds: Array<any> = [];
  showUserLocation: boolean = true;
  userLocation: any;
  selected: string;
  loading: boolean = true;
  showDialog: boolean = false;
  dialogMsg: string;
  showDetectionCancel: boolean = false;
  openCopyModal: boolean = false;
  copyAddress: string = '';
  filterListText: string = '';
  listPositionUp: boolean = false;

  constructor(private session: SessionService,
              private agencyLocationService: AgencyLocationService,
              private mapService: MapService,
              private agencyService: AgencyService,
              private changeDetectorRef: ChangeDetectorRef,
              private router: Router) {}

  ngOnInit() {
    const params = new URLSearchParams();
    const agencyId = this.session.agency_id;

    params.set('agency_id', agencyId);
    params.set('limit', '10000');

    this.agencyLocationService.list({search: params})
      .subscribe(res => {
        // if only 1 location, skip to survey-list
        if (res.length === 1) this.router.navigateByUrl(`/l/survey-list/${res[0].location_id}`);

        this.locations = res;
        this.buildMap();
        this.loading = false;
      }, err => console.log(err));

    this.agencyService.detail(agencyId)
      .subscribe(res => {
        this.agencyName = res.name;
      }, err => console.log(err));
  }

  buildMap() {
    this.map = new Map({
        container: 'map',
        style: 'mapbox://styles/usebenchmark/cixj4g55h001k2rn5wwbuls0d',
        zoom: 3,
        center: [-99.624023, 39.154557],
        attributionControl: false
      })
      .on('click', () => {
        this.clearSelections();
      });

    if (this.locations && this.locations.length > 0) {
      this.addMapLocations();
    }
    this.addUserLocation();

    this.mapService.map = this.map;
  }

  addMapLocations() {
    _.each(this.locations, (l: any) => {
      let marker: any,
          el = document.createElement('div'),
          elLng = document.createAttribute('longitude'),
          elLat = document.createAttribute('latitude');

      elLng.value = l.location.x;
      elLat.value = l.location.y;
      el.setAttributeNode(elLng);
      el.setAttributeNode(elLat);
      el.className = `marker id${l._id}`;
      el.addEventListener('click', (e: any) => {
        e.stopPropagation();
        this.select(l._id);
      });

      marker = new mapboxgl
        .Marker(el, {offset: [this.markerOffset, this.markerOffset]})
        .setLngLat([l.location.x, l.location.y])
        .addTo(this.map);
    });

    this.getLocationBounds();
  }

  getLocationBounds() {
    this.bounds = [
      [_.min(_.map(this.locations, (l:any) => {return l.location.x})) - 0.5,
       _.min(_.map(this.locations, (l:any) => {return l.location.y})) - 0.5],
      [_.max(_.map(this.locations, (l:any) => {return l.location.x})) + 1,
       _.max(_.map(this.locations, (l:any) => {return l.location.y})) + 0.5]
    ];

    this.map.fitBounds(this.bounds);
  }

  addUserLocation() {
    if ("geolocation" in navigator) {
      this.dialogMsg = "Detecting Your Location";
      this.showDetectionCancel = true;
      this.showDialog = true;
      navigator.geolocation.getCurrentPosition((position: any) => {
        if (position.coords && this.showUserLocation) {
          let el = document.createElement('div');
          el.className = `marker user`;

          let marker = new mapboxgl
            .Marker(el, {offset: [this.markerOffset, this.markerOffset]})
            .setLngLat([position.coords.longitude, position.coords.latitude])
            .addTo(this.map);

          this.showDialog = false;
          this.map.flyTo({
            center: [position.coords.longitude, position.coords.latitude],
            zoom: 10
          });
        }
      }, (err: any) => {
        this.showDialog = false;
        if (err.code == err.PERMISSION_DENIED)
          console.log("Geolocation Permission Denied");
      });
    } else {
      console.log('Geolocation Not Available');
    }
  }

  cancelUserLocation() {
    this.showUserLocation = false;
    this.showDialog = false;
  }

  select(id: any, fromList?: boolean) {
    let selectedMarker: any;

    if (this.selected !== id) {
      // highlight selected location in list & map
      this.clearSelections();
      this.selected = id;
      selectedMarker = this.mapHost.nativeElement.querySelector(`.id${id}`);
      if (!selectedMarker.classList.contains('selected'))
        selectedMarker.classList.add('selected');
    } else { return; }

    if (fromList) {
      // Selected From List, so fly map to selected location
      let lng = selectedMarker.getAttribute('longitude'),
          lat = selectedMarker.getAttribute('latitude');
      this.map.flyTo({center: [lng, lat]});
    } else {
      // Selected From Map, so scroll selected to top of list
      if (this.listHost.nativeElement.scrollHeight < this.listHost.nativeElement.clientHeight) return;

      // update view so heights are accurate
      this.changeDetectorRef.detectChanges();

      let selectedListItem = _.find(this.listHost.nativeElement.children, (i: any) => {
        return i.id === `id${id}`;
      });

      if (selectedListItem) {
        // smooth scroll (inspired by https://jsfiddle.net/s61x7c4e/)
        let duration = 500,
            startingY = this.listHost.nativeElement.scrollTop,
            selectedY = selectedListItem.offsetTop,
            targetY = this.listHost.nativeElement.scrollHeight - selectedY < this.listHost.nativeElement.clientHeight ?
                      this.listHost.nativeElement.scrollHeight - this.listHost.nativeElement.clientHeight : selectedY,
            easing = (t) => { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 },
            start,
            diff = targetY - startingY;

        if (!diff) return;

        let _listHost = this.listHost.nativeElement;

        window.requestAnimationFrame(function step(timestamp) {
          if (!start) start = timestamp;
          let time = timestamp - start,
              percent = easing(Math.min(time / duration, 1));

          _listHost.scrollTop = startingY + diff * percent;

          if (time < duration) {
            window.requestAnimationFrame(step)
          }
        });
      }
    }
  }

  clearSelections() {
    let selectedMarker = this.mapHost.nativeElement.querySelector('.selected');
    if (selectedMarker) {
      selectedMarker.classList.remove('selected');
    }

    this.selected = '';
  }

  showCopyModal(address: string, input: any) {
    this.copyAddress = address;
    this.openCopyModal = true;
    input.focus();
  }
}



// WEBPACK FOOTER //
// ./src/app/location-list/location-list.component.ts